import { ElementType } from 'react';

import store from '.';
import * as actions from './actions';
import { LinkParams, ImageState, WidgetSettings, NotificationType } from './types';


export function addUserMessage(message: {text: string, senderName: string, messageId: string, isAcknowledged: boolean}, timestamp = new Date()) {
  store.dispatch(actions.addUserMessage({
    ...message, timestamp,

  }));
}

export function addResponseMessage({ text, buttons, files, senderName, messageId }, timestamp = new Date()) {
  store.dispatch(actions.addResponseMessage({ text, buttons, files, senderName, messageId, timestamp }));
}

export function changeButtonStartState(showStart: boolean) {
  store.dispatch(actions.changeButtonStartStateAction(showStart));
}

export function addTranscriptionMessage(text: string, final = false) {
  store.dispatch(actions.addTranscriptionMessage({ text, final }));
}

export function addLinkSnippet(link: LinkParams, id?: string) {
  store.dispatch(actions.addLinkSnippet(link, id));
}

export function toggleMsgLoader() {
  store.dispatch(actions.toggleMsgLoader());
}

export function renderCustomComponent(component: ElementType, props: any, showAvatar = false, id?: string) {
  store.dispatch(actions.renderCustomComponent(component, props, showAvatar, id));
}

export function toggleWidget() {
  store.dispatch(actions.toggleChat());
}

export function toggleInputDisabled() {
  store.dispatch(actions.toggleInputDisabled());
}

export function dropMessages() {
  store.dispatch(actions.dropMessages());
}

export function isWidgetOpened(): boolean {
  return store.getState().behavior.showChat;
}

export function setQuickButtons(buttons: Array<{ label: string, value: string | number }>) {
  store.dispatch(actions.setQuickButtons(buttons));
}

export function deleteMessages(count: number, id?: string) {
  store.dispatch(actions.deleteMessages(count, id));
}

export function markAllAsRead() {
  store.dispatch(actions.markAllMessagesRead());
}

export function setBadgeCount(count: number) {
  store.dispatch(actions.setBadgeCount(count));
}

export function openFullscreenPreview(payload: ImageState) {
  store.dispatch(actions.openFullscreenPreview(payload));
}

export function closeFullscreenPreview() {
  store.dispatch(actions.closeFullscreenPreview());
}

export function setUserAuthorizedStateAction(isAuthorized: boolean) {
  store.dispatch(actions.setUserAuthorizedStateAction(isAuthorized));
}

export function toggleConnectionAwaiting(status?: boolean) {
  store.dispatch(actions.toggleConnectionAwaiting(status));
}

export function setOperatorPrinting(isPrinting: boolean) {
  store.dispatch(actions.setOperatorPrinting(isPrinting));
}

export const updateWidgetSettingsAction = (settings: WidgetSettings) => {
  store.dispatch(actions.updateWidgetSettings(settings));
};

export function markAsAcknowledged(messageId: string) {
  store.dispatch(actions.markAck(messageId, true));
}

export function showNotification(message: string, type: NotificationType) {
  store.dispatch(actions.showNotification(message, type));
}
